<template>
	<div v-loading="loading" element-loading-text="数据上传中请耐心等待" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<div class="text-left"><el-button type="primary" size="mini" @click="dialogVisible = true">上传ZIP主题包</el-button></div>
				<el-table :data="themeList" style="width: 100%;margin-bottom: 20px;" row-key="" :stripe="true" tooltip-effect="dark" ref="multipleTable">
					<el-table-column prop="thid" label="序号ID" width="110" sortable></el-table-column>
					<el-table-column prop="theme_name" label="网站主题"></el-table-column>
					<el-table-column prop="theme_dir" label="主题文件夹"></el-table-column>
					<el-table-column prop="addtime" label="创建时间"></el-table-column>
					<el-table-column label="操作" width="220">
						<template slot-scope="scope">
							<template v-if="scope.row.filetype != 'dir'">
								<el-button type="success" size="mini" @click="chooseTheme(scope.row)" :disabled="scope.row.ischecked==1">启用主题</el-button>
								<el-button type="danger" size="mini" @click="deleteTheme(scope.row)" :disabled="scope.row.ischecked==1">删除主题</el-button>
							</template>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
		</el-container>
		<el-dialog title="上传网站主题" :visible.sync="dialogVisible" width="80%" style="text-align: left;" :close-on-click-modal="false">
			<el-row style="line-height: 40px;margin-top: 20px;">
				<el-col :span="3">网站主题名称</el-col>
				<el-col :span="9"><el-input v-model="themeInfo.theme_name" type="text" placeholder="请输入主题名称"></el-input></el-col>
			</el-row>
			<el-row style="line-height: 40px;margin-top: 20px;">
				<el-col :span="3">主题文件夹</el-col>
				<el-col :span="9"><el-input v-model="themeInfo.theme_dir" type="text" placeholder="请输入文件夹名称"></el-input></el-col>
			</el-row>
			<el-row style="line-height: 40px;margin-top: 20px;">
				<el-col :span="3">主题类型</el-col>
				<el-col :span="9">
					<el-radio-group v-model="themeInfo.theme_type">
						<el-radio label="web">网站主题</el-radio>
						<el-radio label="wap">手机主题</el-radio>
					</el-radio-group>
				</el-col>
			</el-row>
			<el-upload
				ref="fileupload"
				class="upload-demo"
				drag
				:action="HOST + '/admin.files/uploadZip'"
				:data="{ adminid: JSON.parse($store.state.user.userInfo).id, token: JSON.parse($store.state.user.userInfo).token, theme_dir: themeInfo.theme_dir }"
				:on-success="file => fileUploaded(file, '')"
				:on-remove="file => fileRemove(file, '')"
				:auto-upload="false"
			>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将文件压缩包拖到此处，或
					<em>点击上传</em>
				</div>
			</el-upload>
			<div slot="footer" class="dialog-footer text-center">
				<el-button type="success" @click="uploadFile">确 定</el-button>
				<el-button type="warning" @click="dialogVisible = false">关闭窗口</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
	name: 'webThemes',
	data() {
		return {
			loading:false,
			themeList: [],
			dialogVisible: false,
			themeInfo: {
				theme_dir: '',
				theme_name: '',
				theme_type: 'web'
			}
		};
	},
	mounted() {
		this.getWebThemes();
	},
	methods: {
		...mapMutations({
			setPageRefresh: 'auth/setPageRefresh'
		}),
		getWebThemes() {
			this.$axios({
				url: this.HOST + '/admin.files/getWebThemes',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.themeList = res.data;
					}
				})
				.catch(err => {});
		},
		uploadFile() {
			if (!this.themeInfo.theme_dir) {
				this.$message.error('请输入解压后的文件夹名');
				return false;
			}
			this.loading = true;
			var files = this.$refs.fileupload.uploadFiles;
			if(files.length){
				this.$refs.fileupload.submit();
			}else{
				this.uploadTheme();
			}
			
		},
		// 文件上传回调
		fileUploaded(res, name) {
			console.log(res, name);
			if (res.status == 1) {
				this.uploadTheme();
			} else {
				this.loading = false;
				this.$message.error('文件格式不支持，请重试');
				this.$refs.fileupload.clearFiles();
			}
		},
		// 存储主题
		uploadTheme() {
			this.$axios({
				url: this.HOST + '/admin.files/uploadTheme',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					themeInfo: this.themeInfo
				}
			})
				.then(res => {
					console.log(res.data);
					this.loading = false;
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.setPageRefresh(true);
						this.$refs.fileupload.clearFiles();
						this.dialogVisible = false;
						this.getWebThemes();
					}
				})
				.catch(err => {});
		},
		// 图片移除
		fileRemove(file, name) {
			console.log(file, name);
		},
		// 文件删除
		tempFileDelete(scope) {
			console.log(scope);
			this.$confirm('是否要删除模板文件？此操作一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.files/deleteFile',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							filepath: this.path,
							filename: scope.filename
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getWebThemes();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		// 选中主题
		chooseTheme(scope){
			let list = JSON.parse(JSON.stringify(this.themeList));
			list.map(item=>{
				if(item.theme_type==scope.theme_type){
					item.ischecked = item.thid==scope.thid?1:0;
				}
			})
			this.$axios({
				url: this.HOST + '/admin.files/chooseTheme',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					themeList: list,
					theme_type:scope.theme_type+'_theme',
					type_value:scope.theme_dir
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.themeList = list;
					}
				})
				.catch(err => {});
		},
		// 删除主题
		deleteTheme(scope){
			this.$confirm('是否要删除此网站主题？此操作一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.files/deleteTheme',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							theme_dir: scope.theme_dir,
							theme_id :scope.thid
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getWebThemes();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
			
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
			margin-right: 10px;
		}
	}
}
</style>
